import { Fragment } from 'react'
import { Text } from '@chakra-ui/react'

import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'

type Props = {
  children: JSX.Element
  text?: string
}

export default function CustomFormEmptyAnswerFeedback({ text = 'Sem resposta', children }: Props) {
  const { answer } = useCustomFormAnswer()

  if (!answer.answer || answer.answer[0] === '') {
    return (
      <Text variant="secondary" fontStyle="italic">
        {text}
      </Text>
    )
  }

  return <Fragment>{children}</Fragment>
}
